import removeBasePath from './removeBasePath'
import { TCampaignItem } from '../../types/mainNavigation'

export const getEecPromoImpressionEventForNewsletter = (pathName: string) => {
  return {
    event: 'eecPromoImpression',
    ecommerce: {
      promoView: {
        promotions: [
          {
            id: 'footer',
            name: 'newsletter | footer',
            creative: `${removeBasePath(pathName)} | footer`,
            dimension63: 'Newsletter Module',
          },
        ],
      },
    },
  }
}

export const getEecPromoImpressionEventForCampaign = (campaign: TCampaignItem, pathName: string) => {
  return {
    event: 'eecPromoImpression',
    ecommerce: {
      promoView: {
        promotions: [
          {
            id: `Sales Module - ${campaign.internalName} | ${campaign.contentfulId}`,
            name: `Flyout Navigation | ${campaign.internalName}`,
            creative: `${removeBasePath(pathName)} | ${removeBasePath(campaign.targetUrl)}`,
            dimension63: 'Sales Module',
          },
        ],
      },
    },
  }
}
